"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_TYPE = void 0;
exports.TEMPLATE_TYPE = {
    LANDING: 'LANDING',
    QUIZ: 'QUIZ',
    SHOP: 'SHOP',
    SUBLANDER: 'SUBLANDER'
};
//# sourceMappingURL=templateType.js.map